// init reactN
import { setGlobal } from 'reactn';
import auth from './auth';
export * from './env';
setGlobal({
  ...auth,
  extraData: null,
  notifications: [],
});
